<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.id" placeholder="Id" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.card_number" placeholder="Number" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-select size="small" v-model="params.opencard_id" clearable placeholder="Cardholder"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in opencardList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.callback_state" clearable placeholder="Callback Status"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in callback_state_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.trans_type" clearable placeholder="Type"
        style="width:100px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in trans_type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.fee_type" clearable placeholder="Fee"
        style="width:100px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in fee_type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.balance_diff" clearable placeholder="Balance Diff"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in balance_diff_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.source" clearable placeholder="SMS source"
        style="width:120px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in normal_man_made" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.amount" placeholder="Amount" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.transaction_id" placeholder="Transaction Id" clearable
          style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.trans_id" placeholder="Trans Id" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.body" placeholder="Body" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-select size="small" v-model="params.create" clearable placeholder="Create"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in create_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-date-picker v-model="params.trans_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date(trans time)" end-placeholder="End date(trans time)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.callback_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date(callback)" end-placeholder="End date(callback)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button type="success" size="small" icon="el-icon-document" @click="exportExcel">Export</el-button>
        <!-- <el-button type="danger" size="small" @click="smsAdd"
          v-if="group_name=='kefu'||dkh_user=='xqs'||dkh_user=='aom'||dkh_user=='ken'||dkh_user=='bess'||dkh_user=='coco'">
          Add SMS</el-button> -->
        <el-button type="danger" size="small" @click="smsAdd">Add SMS</el-button>
        <el-button type="warning" size="small" @click="cancelCallback"
          v-if="dkh_user=='xqs'||dkh_user=='aom'||dkh_user=='ken'||dkh_user=='bess'||dkh_user=='coco'">Revoke
          callback
        </el-button>
        <el-button type="danger" size="small" icon="el-icon-collection-tag" @click="setTag">Set Tag</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 100%;">
      <el-table-column prop="id" label="Id" width="80" align="center">
      </el-table-column>
      <el-table-column prop="card_number" label="Number" width="110">
        <template slot-scope="scope">
          <div>{{scope.row.card_number}}</div>
          <div>{{scope.row.opencard_name}}&nbsp;&nbsp;{{scope.row.operator_name}}</div>
          <div>{{scope.row.sms_user_name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="transaction_id" label="Transaction Id" width="110">
        <template slot-scope="scope">
          <div>{{scope.row.transaction_id}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="Amount/Fee" width="100">
        <template slot-scope="scope">
          <div>{{scope.row.amount}}</div>
          <div v-if="scope.row.fee>0">{{scope.row.fee}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="Balance/Balance Diff" width="100">
        <template slot-scope="scope">
          <div>{{scope.row.balance}}</div>
          <el-link type="danger" :underline="false" v-if="scope.row.balance_diff!=0">{{scope.row.balance_diff}}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="user_phone" label="User/Business/Tran ID" width="120">
        <template slot-scope="scope">
          <div>{{scope.row.user_phone}}</div>
          <div>{{scope.row.business_name}}</div>
          <div v-if="scope.row.trans_id!='0'">{{scope.row.trans_id}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="body" label="Body">
        <template slot-scope="scope">
          <div>{{scope.row.body}}<span v-if="scope.row.create_man"
              style="color:#F56C6C">({{scope.row.create_man}})</span>
          </div>
          <div style="color:#F56C6C" v-if="scope.row.create_sms">
            {{scope.row.create_sms.body}}({{scope.row.create_sms.create_man}})</div>
          <div v-if="scope.row.app_name">
            <el-link type="primary" @click="seeMessage(scope.row.file_url)">{{scope.row.app_name}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="Time" width="180">
        <template slot-scope="scope">
          <div><span style="color:#909399">trans：</span>{{scope.row.trans_time|timestampToTime}}</div>
          <div><span style="color:#909399">sms：</span>{{scope.row.sms_time|timestampToTime}}</div>
          <div><span style="color:#909399">add：</span>{{scope.row.save_time|timestampToTime}}</div>
          <div><span style="color:#909399">callback：</span>{{scope.row.callback_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="trans_type" label="Type" width="140" align="center">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" v-if="scope.row.trans_type==1">Recharge</el-link>
          <el-link type="warning" :underline="false" v-if="scope.row.trans_type==2">Withdraw</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.trans_type==3">Recharge refund</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.trans_type==4">Withdraw refund</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="callback_state" label="Callback Status" width="130" align="center">
        <template slot-scope="scope">
          <el-link type="danger" icon="el-icon-edit"
            @click="setFlag(scope.row.id,scope.row.flag,scope.row.flag_business)" :underline="false"
            v-if="scope.row.callback_state==0">Pending
          </el-link>
          <el-link type="danger" icon="el-icon-edit"
            @click="setFlag(scope.row.id,scope.row.flag,scope.row.flag_business)" :underline="false"
            v-if="scope.row.callback_state==3">Match failed
          </el-link>
          <el-link type="warning" :underline="false" v-if="scope.row.callback_state==2">Failed
          </el-link>
          <div v-if="scope.row.flag" style="color:#909399">{{scope.row.flag|flagstate}}</div>
          <div v-if="scope.row.flag==1" style="color:#909399">{{scope.row.flag_business}}</div>
          <el-link type="success" :underline="false" v-if="scope.row.callback_state==1">Success
          </el-link>
          <el-link type="info" :underline="false" v-if="scope.row.callback_state==4">Abnormal
          </el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="140">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="scope.row.flag==0&&scope.row.business_id>0"
            @click="messageCallback(scope.row)">
            Callback Details</el-button>
          <!-- <div v-else>
            <el-button size="mini" type="success" v-if="!scope.row.business_name" @click="messageCallback(scope.row)">
              Send Callback</el-button>
          </div> -->
          <div style="margin-top:10px">
            <el-button size="mini" type="warning" v-if="scope.row.balance_diff!=0" @click="nearbySms(scope.row.id)">
              Nearby SMS</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog title="Set up tag" :visible.sync="flagVisible" width="35%" @click='closeDialog("flag")'>
      <el-form :inline="true" label-width="120px" :model="editflag">
        <el-form-item label=" " prop="flag">
          <el-radio-group v-model="editflag.flag">
            <el-radio style="margin-bottom:20px" :label="item.k" v-for="(item,index) in flag_list" :key="index">
              {{item.v}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label=" " prop="flag_business">
          <el-radio-group v-model="editflag.flag_business">
            <el-radio style="margin-bottom:20px" :label="item.name" v-for="(item,index) in business_list" :key="index">
              {{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("flag")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitflag">Save
        </el-button>
      </div>
    </el-dialog>
    <!-- Callback Details -->
    <el-dialog title="" :visible.sync="callbackVisible" @click='closeDialog("callback")' width="50%">
      <el-descriptions title="Callback Details" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback URL" span="2"
          v-if="messageInfo.callback_url">{{messageInfo.callback_url}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Select Business" span="2" v-else>
          <el-radio-group v-model="new_business_id">
            <el-radio v-for="item in business_callback_list" :key="item.name" :label="item.business_id">{{item.name}}
            </el-radio>
          </el-radio-group>
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback nums">{{messageInfo.error_num}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback Status">
          <el-link type="danger" :underline="false" v-if="messageInfo.callback_state==0">Pending
          </el-link>
          <el-link type="warning" :underline="false" v-if="messageInfo.callback_state==3">Match failed
          </el-link>
          <el-link type="danger" :underline="false" v-if="messageInfo.callback_state==2">Failed
          </el-link>
          <el-link type="success" :underline="false" v-if="messageInfo.callback_state==1">Success
          </el-link>
          <el-link type="info" :underline="false" v-if="messageInfo.callback_state==4">abnormal
          </el-link>
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Type" span="2">
          {{messageInfo.trans_type|transtypestate}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback Datas" :column="2" span="2">{
          "trans_id": "{{messageInfo.trans_id}}",
          "card_number": "{{messageInfo.card_number}}",
          "amount": "{{messageInfo.amount}}",
          "currency": "{{messageInfo.currency}}",
          "fee": {{messageInfo.fee}},
          "user_phone": "{{messageInfo.user_phone}}",
          "transaction_id": "{{messageInfo.transaction_id}}",
          "country": "{{messageInfo.country}}",
          "address": "{{messageInfo.address}}",
          "trans_type": {{messageInfo.trans_type}},
          "body": "{{messageInfo.body}}",
          "trans_time": {{messageInfo.trans_time}},
          "sms_time": {{messageInfo.sms_time}}
          }</el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="User Phone" span="2"
          v-if="messageInfo.callback_state==2&&messageInfo.trans_type==1">
          <el-input type="number" style="width:200px" size="small" v-model="user_phone" placeholder="修改用户号码" clearable>
          </el-input>
        </el-descriptions-item>
      </el-descriptions>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="messageInfo.callback_state==2&&messageInfo.trans_type==1" size="small" type="warning"
          :loading="loading" class="title" @click="rematchOrder(messageInfo.id)">Rematch Order
        </el-button>
        <el-button size="small" type="danger" :loading="loading" class="title"
          @click="submitCancelBack(messageInfo.id)">Revoke Callback
        </el-button>
        <el-button v-if="messageInfo.callback_state==3&&messageInfo.trans_type==3" size="small" type="success"
          :loading="loading" class="title" @click="submitResendBack(messageInfo.id)">Resend Callback
        </el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="callbackSubmit"
          v-if="messageInfo.callback_state==2">Detect Callback</el-button>
        <div style="margin-top: 20px;color: #F56C6C;" v-if="detect_callback">{{detect_callback}}</div>
      </div>
    </el-dialog>
    <!-- Add SMS -->
    <el-dialog title="Add SMS" :visible.sync="smsAddVisible" @click='closeDialog("smsAdd")'>
      <el-form :inline="true" label-width="120px" :model="smsAddForm" ref="smsAddForm" :rules="rules">
        <el-form-item label="Business" prop="business_name">
          <!-- <el-select size="small" v-model="smsAddForm.business_id" clearable placeholder="Please select business">
            <el-option v-for="item in business_list" :key="item.k" :label="item.name" :value="item.id">
            </el-option>
          </el-select> -->
          <el-cascader :options="country_business" size="small"
            :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
            placeholder="Country/Business" @change="cascaderChangeAddSMS" style="position:relative;right:2px">
          </el-cascader>
        </el-form-item>
        <el-form-item label="Phone" prop="user_phone">
          <el-input size="small" v-model="smsAddForm.user_phone" auto-complete="off" placeholder="User phone" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Transaction Id" prop="transaction_id">
          <el-input size="small" v-model="smsAddForm.transaction_id" auto-complete="off" placeholder="Transaction Id"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Amount" prop="amount">
          <el-input size="small" type="number" v-model="smsAddForm.amount" auto-complete="off" placeholder="Amount"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Is USD?" prop="is_usd">
          <el-radio-group v-model="smsAddForm.is_usd">
            <el-radio :label="1">NO</el-radio>
            <el-radio :label="2">YES</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Fee" prop="fee">
          <el-input size="small" type="number" v-model="smsAddForm.fee" auto-complete="off" placeholder="Fee" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Trans Time" prop="trans_time">
          <el-date-picker size="small" v-model="smsAddForm.trans_time" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="Trans Time" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Card Number" prop="card_number">
          <el-input size="small" v-model="smsAddForm.card_number" auto-complete="off" placeholder="Card Number"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="Type" prop="trans_type">
          <el-radio-group v-model="smsAddForm.trans_type">
            <el-radio :label="1">Recharge</el-radio>
            <el-radio :label="3">Recharge refund</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("smsAdd")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitSmsAdd('smsAddForm')">Save
        </el-button>
      </div>
    </el-dialog>
    <!-- Revoke callback -->
    <el-dialog title="Revoke callback" :visible.sync="cancelCallbackVisible" @click='closeDialog("cancelCallback")'>
      <el-form :inline="true" label-width="120px" :model="cancelCallbackId" ref="cancelCallbackId">
        <el-form-item label="Start Id" prop="start_id">
          <el-input size="small" type="number" v-model="cancelCallbackId.start_id" auto-complete="off"
            placeholder="Start Id，Single can be empty" clearable>
          </el-input>
        </el-form-item>
        <br />
        <el-form-item label="End Id" prop="end_id">
          <el-input size="small" type="number" v-model="cancelCallbackId.end_id" auto-complete="off"
            placeholder="End Id，Single can be empty" clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("cancelCallback")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitCancelCallback">Confirm
        </el-button>
      </div>
    </el-dialog>

    <!-- nearbySmsVisible -->
    <el-dialog title="Nearby SMS" :visible.sync="nearbySmsVisible" @click='closeDialog("nearbySms")' width="50%">
      <el-table size="small" :data="nearby_sms" highlight-current-row v-loading="loading"
        element-loading-text="Loading...">
        <el-table-column prop="id" label="ID" width="60" align="center">
        </el-table-column>
        <el-table-column prop="card_number" label="Card number" width="100">
        </el-table-column>
        <el-table-column prop="amount" label="Amount/balance/diff" width="110">
          <template slot-scope="scope">
            <div>{{scope.row.amount}}</div>
            <div>{{scope.row.balance}}</div>
            <div>{{scope.row.balance_diff}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="body" label="Body">
        </el-table-column>
        <el-table-column prop="trans_time" label="Trans time" width="180">
          <template slot-scope="scope">
            {{scope.row.trans_time|timestampToTime}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {
    smsListNew,
    updateFlag,
    messageCallback,
    transBusinessList,
    smsAdd,
    smsCancelCallback,
    cardAttachList,
    getCountryBusiness,
    getNearbySms,
    setSmsTagCheck,
    resendCallback,
    rematchOrders
  } from '../../api/apiFun'
  import {
    timestampToTime,
    exportUrl,
    getCookie,
    cascaderChange,
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  let that = ""
  export default {
    data() {
      return {
        group_name: getCookie('group_name'),
        dkh_user: getCookie('dkh_user'),
        loading: false, //是显示加载
        examineVisible: false, //控制Edit页面显示与隐藏
        params: {
          page: 1,
          limit: 10,
          id: '',
          card_number: '',
          amount: '',
          transaction_id: '',
          callback_time: '',
          trans_time: '',
          save_time: '',
          trans_type: '',
          callback_state: '',
          body: '',
          fee_type: '',
          flag: '',
          business_name: '',
          country: '',
          opencard_id: '',
          balance_diff: '',
          source: '',
          trans_id: '',
          create:''
        },
        fee_type_list: [{
          k: 1,
          v: 'equal to 0'
        },
        {
          k: 2,
          v: 'not equal to 0'
        }
        ],
        balance_diff_list: [{
          k: 1,
          v: 'equal to 0'
        },
        {
          k: 2,
          v: 'not equal to 0'
        }
        ],
        normal_man_made: [{
          k: 1,
          v: 'Man made'
        },
        {
          k: 2,
          v: 'Normal'
        }
        ],
        trans_type_list: [{
          k: 1,
          v: 'Recharge'
        },
        {
          k: 2,
          v: 'Withdraw'
        },
        {
          k: 3,
          v: 'Recharge refund'
        },
        {
          k: 4,
          v: 'Withdraw refund'
        },
        ],
        callback_state_list: [{
          k: '3',
          v: 'Match failed'
        },
        {
          k: 0,
          v: 'Pending'
        },
        {
          k: '1',
          v: 'Success'
        },
        {
          k: '2',
          v: 'Failed'
        },
        {
          k: '1,2',
          v: 'Success/Failed'
        },

        {
          k: '4',
          v: 'Abnormal'
        }
        ],
        create_list: [
          {
            k: '1',
            v: 'YES'
          },
          {
            k: '2',
            v: 'NO'
          },
        ],
        flag_list: [{
          k: 1,
          v: 'Business withdrawal'
        },
        {
          k: 2,
          v: 'Our withdrawal'
        },
        {
          k: 3,
          v: 'kaka'
        },
        {
          k: 4,
          v: 'Withdraw repeat'
        },
        {
          k: 5,
          v: 'Withdraw wrong'
        },
        {
          k: 6,
          v: 'Withdraw complement'
        },
        {
          k: 7,
          v: 'Test'
        },
        {
          k: 8,
          v: 'Others'
        },
        {
          k: 9,
          v: 'Unlock fee'
        },
        {
          k: 10,
          v: 'Refund'
        },
        {
          k: 11,
          v: 'SMS delay'
        },
        ],
        listData: [], //User数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        opencardList: [],
        pickerOptions: {
          shortcuts: [{
            text: 'Today',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        flagVisible: false,
        editflag: {
          id: 0,
          flag: 0,
          flag_business: ''
        },
        smsAddVisible: false,
        smsAddForm: {
          business_name: '',
          user_phone: '',
          transaction_id: '',
          trans_time: '',
          amount: '',
          is_usd: 1,
          trans_type: 1,
          fee: 0,
          card_number: '',
        },
        rules: {
          user_phone: [{
            required: true,
            message: 'Please enter phone',
            trigger: 'blur'
          }],
          transaction_id: [{
            required: true,
            message: 'Please enter Transaction Id',
            trigger: 'blur'
          }],
          amount: [{
            required: true,
            message: 'Please enter amount',
            trigger: 'blur'
          }],
          is_usd: [{
            required: true,
            message: 'Please select amount',
            trigger: 'blur'
          }],
          trans_type: [{
            required: true,
            message: 'Please select type',
            trigger: 'blur'
          }],
        },
        business_list: [],
        callbackVisible: false,
        messageInfo: {},
        cancelCallbackVisible: false,
        cancelCallbackId: {
          start_id: '',
          end_id: ''
        },
        business_callback_list: [],
        new_business_id: '',
        country_business: [],
        nearbySmsVisible: false,
        nearby_sms: [],
        detect_callback: '',
        user_phone: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
      smsListNewstate: function (i) {
        var v = '';
        that.state_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
      flagstate: function (i) {
        var v = '';
        that.flag_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
      transtypestate: function (i) {
        var v = '';
        that.trans_type_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
    },
    created() {
      that = this
      this.getdata(this.params)
      this.transBusinessList()
      this.getCountryBusiness()
      this.cardAttachList()
    },
    methods: {
      setTag() {
        if (this.params.callback_state !== '3' && this.params.callback_state !== 0) {
          this.$message.error(
            'The callback status can only be set tag when the callback status is equal to "Match failed" or "Pending".'
          )
          return
        }
        setSmsTagCheck(this.params).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.flagVisible = true
            this.editflag.id = res.datas
          }
        }).catch(err => {
          this.$message.error('Failed to setTag, please try again later!')
        })
      },
      nearbySms(id) {
        getNearbySms({
          id: id
        }).then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.nearby_sms = res.datas;
            this.nearbySmsVisible = true
          }
        }).catch(err => {
          this.$message.error('Failed to get nearbySms, please try again later!')
        })
      },
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.params.country = cascader[0]
        this.params.business_name = cascader[1]
      },
      cascaderChangeAddSMS(value) {
        var cascader = cascaderChange(value)
        this.smsAddForm.business_name = cascader[1]
      },
      cardAttachList() {
        cardAttachList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.opencardList = res.datas.opencard_list
          }
        }).catch(err => {
          this.$message.error('Failed to get cardholder information, please try again later!')
        })
      },
      rematchOrder(id) {
        this.$confirm('您确定要将订单状态改为pendding，然后重新匹配订单吗?', '提示', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.loading = true
          rematchOrders({ id: id, user_phone: this.user_phone }).then(res => {
            this.loading = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success'
              })
              this.getdata(this.params)
              this.callbackVisible = false
              this.$message({
                type: 'success',
                message: '订单状态修改成功'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('订单状态修改失败')
          })
        }).catch(() => {
          ;
        });
      },
      submitCancelBack(id) {
        this.cancelCallbackId.start_id = id
        this.$confirm('This operation will be irreversible, whether to continue?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.loading = true
          smsCancelCallback(this.cancelCallbackId).then(res => {
            this.loading = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success'
              })
              this.getdata(this.params)
              this.callbackVisible = false
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Cancellation SMS callback failed, please try again later!')
          })
        }).catch(() => {
          ;
        });
      },
      submitCancelCallback() {
        if (!this.cancelCallbackId.start_id && !this.cancelCallbackId.end_id) {
          this.$message.error('Start Id and End Id cannot be empty!')
          return
        }
        if (this.cancelCallbackId.start_id && this.cancelCallbackId.end_id) {
          if (this.cancelCallbackId.start_id > this.cancelCallbackId.end_id) {
            this.$message.error('Start Id cannot be greater than End Id!')
            return
          }
        }
        this.$confirm('This operation will be irreversible, whether to continue?', 'Tips', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.loading = true
          smsCancelCallback(this.cancelCallbackId).then(res => {
            this.loading = false
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'success'
              })
              this.getdata(this.params)
              this.cancelCallbackVisible = false
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('Cancellation SMS callback failed, please try again later!')
          })
        }).catch(() => {
          ;
        });

      },
      cancelCallback() {
        this.cancelCallbackVisible = true
      },
      submitSmsAdd(smsAddForm) {
        if (!this.smsAddForm.business_name) {
          this.$message.error('Please select business')
          return
        }
        this.loading = true
        this.$refs[smsAddForm].validate(valid => {
          if (valid) {
            smsAdd(this.smsAddForm).then(res => {
              this.loading = false
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: 'success'
                })
                this.getdata(this.params)
                this.smsAddVisible = false
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.loading = false
              this.$message.error('Failed, please try again later!')
            })
          } else {
            this.loading = false
            return false
          }
        })
      },
      smsAdd() {
        this.smsAddVisible = true
      },
      transBusinessList() {
        transBusinessList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            var business_list = res.datas.list;
            business_list.push({
              "id": 0,
              "name": "system number"
            }, {
              "id": 0,
              "name": "hide number"
            });
            this.business_list = business_list
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      messageCallback(row) {
        var business_list = this.business_list
        var business_callback_list = [];
        business_list.forEach(item => {
          if (item.country == row.country && item.callback_url) {
            business_callback_list.push({
              business_id: item.id,
              name: item.name,
              country: item.country,
              callback_url: item.callback_url,
            })
          }
        });
        this.business_callback_list = business_callback_list
        this.messageInfo = row
        this.new_business_id = ''
        this.detect_callback = ''
        this.callbackVisible = true
        this.user_phone = row.user_phone
      },
      submitResendBack() {
        this.loading = true
        resendCallback({
          id: this.messageInfo.id,
        }).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.callbackVisible = false
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Resend success'
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to send callback, please try again later!')
        })
      },
      callbackSubmit() {
        this.loading = true
        messageCallback({
          id: this.messageInfo.id,
          new_business_id: this.new_business_id,
        }).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.detect_callback = JSON.stringify(res.datas)
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to send callback, please try again later!')
        })
      },
      setFlag(id, flag, flag_business) {
        this.flagVisible = true
        this.editflag.id = id
        this.editflag.flag = flag
        this.editflag.flag_business = flag_business
      },
      submitflag() {
        this.loading = true
        if (this.editflag.flag == 0) {
          this.$message.error('Please select flag!')
          return
        }
        updateFlag(this.editflag).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.flagVisible = false
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Set up tag success'
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed, please try again later!')
        })
      },
      exportExcel() {
        window.location.href = exportUrl('/admin/sms/export_sms', this.params);
      },
      // 获取SMS list
      getdata(parameter) {
        if (parameter.trans_time == null) {
          parameter.trans_time = ''
        }
        if (parameter.callback_time == null) {
          parameter.callback_time = ''
        }
        if (parameter.save_time == null) {
          parameter.save_time = ''
        }
        this.loading = true
        smsListNew(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get SMS list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      seeMessage(file_url) {
        window.open(file_url, "_blank");
      },
      closeDialog(type) {
        if (type == 'flag') {
          this.flagVisible = false
        }
        if (type == 'callback') {
          this.callbackVisible = false
        }
        if (type == 'smsAdd') {
          this.smsAddVisible = false
        }
        if (type == 'cancelCallback') {
          this.cancelCallbackVisible = false
        }
        if (type == 'nearbySms') {
          this.nearbySmsVisible = false
        }
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/sms/sms_list.vue